import { defineStore } from 'pinia';

const findFacet = (state, name) => state.facets.find((facet) => facet.name === name);

export const useFilteringFacetsStore = defineStore('filteringFacets', {
  state: () => ({
    facets: [],
    sortBy: {
      selectedValue: null,
      sortByOptions: [],
    },
  }),
  getters: {
    getSortBy: (state) => state.sortBy,
    getFacets: (state) => state.facets,
    getFacetByName: (state) => (name) => findFacet(state, name),
    allSelectedCriteria: (state) => ({
      sortBy: state.sortBy.selectedValue,
      facets: state.facets.filter((facet) => facet.selectedValues?.length).map(({ name, selectedValues }) => ({ name, selectedValues })),
    }),
  },
  actions: {
    addFacetOptions(value) {
      this.facets = value.facets;
    },
    addSortByOptions(value) {
      const { sortBy } = value;
      this.sortBy.sortByOptions = sortBy;
      this.sortBy.selectedValue = sortBy?.length ? sortBy[0].value : null;
    },
    updateSortBySelected(value) {
      this.sortBy.selectedValue = value;
    },
    replaceSelectedValues(criteria) {
      const facet = findFacet(this, criteria.name);
      if (facet) facet.selectedValues = criteria.selectedValues;
    },
    addCheckboxValues(criteria) {
      const facet = findFacet(this, criteria.name);
      if (facet) facet.values.push(criteria.newValue);
    },
    removeCheckboxValuesByValue(criteria) {
      const facet = findFacet(this, criteria.name);
      if (facet) facet.values = facet.values.filter((value) => value.value !== criteria.value);
    },
    getAllSelectedCriteria() {
      // Use for consumer to subscribe this action
    },
  },
});
